export const getProductDataCacheKey =
  "/engagement/:app_group_id/whatsapp/product_data/:messaging_service_id" as const;
